import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { CommonFeatureToggleModule } from '@capital-access/common/feature-toggle';
import { CommonLocalizationModule } from '@capital-access/common/localization';
import { ESG_COMPONENT_KEY } from '@capital-access/esg/common';
import {
  FireflyChipModule,
  FireflyMultilineTextTruncateModule,
  FireflyPopoverModule
} from '@capital-access/firefly/components';
import { EsgCategoriesComponent } from './components/esg-categories/esg-categories.component';
import { EsgCategoriesFilterToggleComponent } from './components/esg-categories-filter-toggle/esg-categories-filter-toggle.component';
import { EsgFilterComponent } from './components/esg-filter/esg-filter.component';
import { EsgTagComponent } from './components/esg-tag/esg-tag.component';
import { EsgSfdrFilterComponent } from './components/sfdr-filter/esg-sfdr-filter.component';
import { SfdrPopoverComponent } from './components/sfdr-popover/sfdr-popover.component';
import { SustainableSwitcherComponent } from './components/sustainable-switcher/sustainable-switcher.component';

@NgModule({
  imports: [
    CommonModule,
    CommonFeatureToggleModule,
    CommonLocalizationModule.forFeature(ESG_COMPONENT_KEY),
    FireflyMultilineTextTruncateModule,
    FireflyPopoverModule,
    FireflyChipModule,
    NgbPopover
  ],
  declarations: [
    SfdrPopoverComponent,
    EsgCategoriesComponent,
    EsgFilterComponent,
    EsgCategoriesFilterToggleComponent,
    SustainableSwitcherComponent,
    EsgTagComponent,
    EsgSfdrFilterComponent
  ],
  exports: [
    SfdrPopoverComponent,
    EsgCategoriesComponent,
    EsgFilterComponent,
    EsgCategoriesFilterToggleComponent,
    SustainableSwitcherComponent,
    EsgTagComponent,
    EsgSfdrFilterComponent
  ]
})
export class EsgComponentsModule {}
